"use client";

import { Toaster as SonnerToaster } from "sonner";
import { useTheme } from "@/lib/theme-context";

export function ThemeToaster() {
  const { resolvedTheme } = useTheme();

  return (
    <SonnerToaster
      position="bottom-right"
      theme={resolvedTheme}
      toastOptions={{
        style: {
          background: "var(--card)",
          color: "var(--foreground)",
          border: "1px solid var(--border)",
        },
      }}
    />
  );
}
